import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { SessionStorageService } from 'ngx-webstorage';
import { DLogger } from '@dian/core';
import { UtilsService } from './../../../../resources/services/utils.service';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { DSesionServicios, DConfigCuentaUsuarioTO, DOperCtaUsuarioTO, DDatosPwdTO, DRtaCuentaUsuarioTO, DUsuarioCuentaTO } from '@dian-api/api-sesion';
import { CondicionesComponent } from '../../../recuperar-pass/components/condiciones/condiciones.component';
import { MedioComunicacion } from '@dian/api-identidad-auth-config';

@Component({
  selector: 'app-cambiar-pass',
  templateUrl: './cambiar-pass.component.html',
  styleUrls: ['./cambiar-pass.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    UtilsService,
    DSesionServicios
  ]
})
export class CambiarPassComponent implements OnInit {

  public loading: boolean = false;
	public mostrarPassword: boolean = false;  
	public mostrarConfirmacion: boolean = false;
  public mostrarPasswordAnterior: boolean = false;
  public confirmPassword: boolean = true;
  public allValidationsOk: boolean = true;
  public validacionesPassword = {    
    longitud: false,
    caracterEspecial: false,
    mayusculasMinusculas: false,
    minimoLetras: false,
    minimoNumeros: false,
    caracteresSeguidos: false,
    acentos: false
  };
  public cuentaModel: DDatosPwdTO;
  public usuarioModel: DUsuarioCuentaTO; 
  public model: DConfigCuentaUsuarioTO;
  public mediosComunicacion: MedioComunicacion[];

  private continuarLogin: boolean = true;
  private operacion: string = "1";
  private ideRequest: string = '';
  condicionesChecked = false;

  constructor(
    private router: Router,
    private _sessionStorage: SessionStorageService,
    private _utils: UtilsService,
    private dialog: MatDialog,
    private _rest: DSesionServicios
  ) {
    this.cuentaModel = new DDatosPwdTO();
    this.usuarioModel = new DUsuarioCuentaTO();
    this.model = new DConfigCuentaUsuarioTO();
  }

  ngOnInit() {    
    this.ideRequest = localStorage.getItem('ideRequest');
    this.model = <DConfigCuentaUsuarioTO>JSON.parse(localStorage.getItem('identificacion'));  
    this.mediosComunicacion = <MedioComunicacion[]>JSON.parse(localStorage.getItem('medios-comunicacion'));      

    let countRetry = 0;

    const idInterval = setInterval(() => {
      if (this.model) {    
        this.model.operacion.codigo = "2";    
        clearInterval(idInterval);
      } else {
        countRetry++;
        this.model = <DConfigCuentaUsuarioTO>JSON.parse(localStorage.getItem('identificacion'));
      }

      if (!this.model && countRetry === 5) {
        this.router.navigate(['habilitar-cuenta/autenticacion']);
      }
    }, 500);
  }  

  public validateRequirementsPassword(value: string) {
    this.allValidationsOk = true;
    //Valida longitud cadena
    this.validacionesPassword.longitud = value ? (/^[\S\s]{6,15}$/).test(value) : false;
    //Minimo 2 letras
    this.validacionesPassword.minimoLetras = value ? (/[A-Za-z]{2,}/).test(value) : false;
    //Minimo numeros
    this.validacionesPassword.minimoNumeros = value ? (/[0-9]{1,}/).test(value) : false;
    //Valida caracter especial
    //this.validacionesPassword.caracterEspecial = (/.*\d{1,}/).test(value); //(/[!@#$%^&*(),.?":{}|<>]/).test(value) && 
    this.validacionesPassword.caracterEspecial = value ? (/[\#\*\(\)\$\%\&\/\\,\¿\?\-\_\@\¡\!\+\.\=]{1,}/).test(value) : false;
    //Valida minusculas y mayusculas
    this.validacionesPassword.mayusculasMinusculas = value ? (/[A-Z]{1,}/).test(value) && (/[a-z]{1,}/).test(value) && (/(?=.*[A-Z])/).test(value) : false;
    //Valida caracteres seguidos
    this.validacionesPassword.caracteresSeguidos = value ? !(/.*(.)\1{5}/).test(value) : false;
    //Valida acentos
    this.validacionesPassword.acentos = value ? !(/[ñÑáéíóúÁÉÍÓÚ]+/g).test(value) : false;
    //this.validacionesPassword.acentos = value ? !((/[ñÑáéíóúÁÉÍÓÚ]+/g).test(value) || (/[^\w\s\][^+\-*.]/gi).test(value)) : false;
    //return (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,15}$/).test(value);  

    Object.entries(this.validacionesPassword).forEach(entry => {
      const [key, value] = entry;
      if (!value) {
        this.allValidationsOk = false;
        return;
      }
    });
  }

  public validatePasswordConfirm(value: string) {
    this.confirmPassword = this.cuentaModel.contrasenaNuevaUsuario === this.cuentaModel.contrasenaConfirmacionUsuario;    
  }

  public cambiarPass() {      
   
    this.loading = true;
    this.cuentaModel = this.encodePasswords(this.cuentaModel);      
    this.model.usuariocuenta.datosPwd = this.cuentaModel;      
    const otp = localStorage.getItem('otp');
    this.model.otp = otp;

    this._rest.habilitarCuentaUsuario(this.model)
      .subscribe(
        res => {  
          this.loading = false;
          const respuesta = <DRtaCuentaUsuarioTO>res; 
         
          //Success
          if (respuesta.codigoRta.tipoRta === "1") {            

            if (respuesta.usuariocuenta.esFuncionario === "true") {              
              this.continuarLogin = !this.continuarLogin && (this.cuentaModel.contrasenaUsuario != null || this.cuentaModel.contrasenaUsuario != '');
              this.mostrarPasswordAnterior = true;
            }          

            //if (this.continuarLogin) {
              this.loading = false;
              const mediosComunicacion = JSON.parse(localStorage.getItem('medios-comunicacion'));
              let message = "";
              let title = "";
              if(mediosComunicacion){
                const emailObj = mediosComunicacion.find(item => item.tipo === "email");
                const email = emailObj ? emailObj.valor : "";

                title = "Contraseña guardada con éxito. Esta será la misma para ingresar y firmar.";
                message =  `Hemos enviado la confirmación de la generación de su Firma Electrónica a: ${email}`;
              }else{
                title = "Contraseña guardada con éxito.";
                message =  ``;
              }
              
              
              let config = {
                disableClose: true,
                maxWidth: 400,
                data: {
                  type: 'success',
                  title: title,
                  message: message,
                  textButton: 'Iniciar sesión',
                  valueButton: 'ok'
                }
              };
              this.dialog.open(NotificationsComponent, config).afterClosed().subscribe(res => {
                localStorage.removeItem('otp');
                localStorage.removeItem('tipo-comunicacion');

                
                const queryParam = this.ideRequest ? this.ideRequest : '';
                this.router.navigate(['/'], { queryParams: { ideRequest: queryParam }});
              });
            //}
          }  

          //Success
          /*if (respuesta.codigoRta.tipoRta === "2") {    
            if (respuesta.usuariocuenta.esFuncionario === "true") {              
              this.continuarLogin = !this.continuarLogin && (this.cuentaModel.contrasenaUsuario != null || this.cuentaModel.contrasenaUsuario != '');
              this.mostrarPasswordAnterior = true;
            }  

            if (this.continuarLogin) {
              this.loading = false;_
              let config = {
                disableClose: true,
                maxWidth: 400,
                data: {
                  type: 'error',
                  title: '¡Error al guardar su contraseña!',
                  message: 'Discúlpenos, intente de nuevo', //respuesta.codigoRta.mensaje,
                  textButton: 'Entendido',
                  valueButton: 'ok'
                }
              };
              this.dialog.open(NotificationsComponent, config);
            }
          } */                 
        },
        error => {     
          this.loading = false;       
          this.showError('Error al guardar su contraseña.', 'Discúlpenos, intente de nuevo');                
        }
      );
  }

  private encodePasswords(model: DDatosPwdTO): DDatosPwdTO {
    if (this.mostrarPasswordAnterior)
      model.contrasenaUsuario = this._utils.utf8ToBase64(model.contrasenaUsuario);
    model.contrasenaNuevaUsuario = this._utils.utf8ToBase64(model.contrasenaNuevaUsuario);
    model.contrasenaConfirmacionUsuario = this._utils.utf8ToBase64(model.contrasenaConfirmacionUsuario);
    return model;
  }

  private showError(title: string = "", mensaje: string = "", textButton: string = "") {
    let config = {
      disableClose: true,
      maxWidth: 400,
      data: {
        type: 'error',
        title: title,
        message: mensaje,
        textButton: textButton,
        valueButton: '',
        classWrap: 'alert alert-error'
      }              
    };
    this.dialog.open(NotificationsComponent, config);    
  }

  launchCondiciones(){
    let config = {
      disableClose: true,
      maxWidth: '80vw',
      data: {}
    };
    let dialogRef = this.dialog.open(CondicionesComponent, config);
    dialogRef.afterClosed().subscribe(result => {
  //    this.condicionesChecked = result;

    }); 
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/cambiar-pass/cambiar-pass.component.ts